import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";

import { reloadOnStaleChunks } from "@/common/routing/chunkLoadError";

// src/ui's MUI theme augmentation (custom typography variants, palette fields), once per app.
import "@/ui/mui/augmentation";

import { ignoreBenignBrowserErrors } from "./configurations/benignBrowserErrors";
import { initSentry } from "./configurations/sentry";
import { store } from "./configurations/store";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

ignoreBenignBrowserErrors();
// A tab still running the previous build reloads once instead of failing its next lazy chunk.
reloadOnStaleChunks();
initSentry();

const container = document.getElementById("root");
if (!container) {
  throw new Error("admin: index.html has no #root element");
}
const root = createRoot(container);

root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <App />
  </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
